/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';

import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

@Injectable()
export class DefaultService {

    constructor(public readonly http: HttpClient) {}

    /**
     * @param path
     * @returns any
     * @throws ApiError
     */
    public getFile(
        path: string,
    ): Observable<any> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/files/{path}',
            path: {
                'path': path,
            },
        });
    }

}